import * as React from 'react';
import styled from 'styled-components';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;

import { Button } from '@process-advisor/process-miner/components/shared/button';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import { FilterType } from '@process-advisor/process-miner/filters/time/filterType';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';

import dayjs, { Dayjs } from 'dayjs';
import { AlertMessage } from '@process-advisor/process-miner/components/alerts/alert';
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
`;

import customParseFormat from 'dayjs/plugin/customParseFormat';

let defaultMin = dayjs().subtract(1, 'day');
let defaultMax = dayjs();

export const TimeTab: React.FC = (mode) => {
    const sleep = ms => new Promise(r => setTimeout(r, ms));
    const [value, setValue] = React.useState<DateRange<Dayjs>>();    
    const [type, setType] = React.useState(apiProvider.getEntityUpper());
    const [valueChanged, setValueChanged] = React.useState(false);
    //const [defaultMin, setDefaultMin] = React.useState()
    //const [defaultMax, setDefaultMax] = React.useState()
    let defaultTime = apiProvider.defaultMinMaxTime()
    dayjs.extend(customParseFormat)
    defaultMin = dayjs(defaultTime.min_time.substring(0,10),'YYYY/MM/DD')
    defaultMax = dayjs(defaultTime.max_time.substring(0,10),'YYYY/MM/DD')

    React.useEffect(() => {
        if (value != undefined) setValueChanged(true)
    }, [value]);

    async function onApply () {
        let fromYear ;
        let fromMonth ;
        let fromDay ;
        let toYear ;
        let toMonth ;
        let toDay ;
    
        await openProgressModal({status: 'Processing Time Filters'})
        await sleep(50)
        if (valueChanged === true) {

            fromYear = dayjs(value[0]).year()
            toYear = dayjs(value[1]).add(1, "day").year()

            if (dayjs(value[0]).month() + 1 < 10) fromMonth = '0' + (dayjs(value[0]).month() + 1)
            else fromMonth = dayjs(value[0]).month() + 1
            if (dayjs(value[1]).add(1, "day").month() + 1 < 10) toMonth = '0' + (dayjs(value[1]).add(1, "day").month() + 1)
            else toMonth = dayjs(value[1]).add(1, "day").month() + 1

            if (dayjs(value[0]).date() < 10) fromDay = '0' + dayjs(value[0]).date()
            else fromDay = dayjs(value[0]).date()
            if (dayjs(value[1]).add(1, "day").date() < 10) toDay = '0' + dayjs(value[1]).add(1, "day").date()
            else toDay = dayjs(value[1]).add(1, "day").date()

            let fromDate = fromYear + "/" + fromMonth + "/" + fromDay;
            let toDate = toYear + "/" + toMonth + "/" + toDay;
                await apiProvider.applyTimeFilter({
                    fromTime: fromDate,
                    toTime: toDate,
                    type: type,
                    mode: mode.mode
                })
        } else {
                await apiProvider.applyTimeFilter({
                    fromTime: '',
                    toTime: '',
                    type: type,
                    mode: mode.mode
                })
        }
        closeProgressModal()
    };

    return (
        <Wrapper>
            <SingleBlock width="25%"/>
            <SingleBlock width="50%">
                <FilterType type={setType} />
            </SingleBlock>
            <SingleBlock width="25%"/>
            <SingleBlock width="5%"/>
            <SingleBlock width="90%">
                <RangePicker defaultValue={[defaultMin,defaultMax]} onChange={(newValue) => setValue(newValue)}/>
            </SingleBlock>
            <SingleBlock width="5%"/>

            <SingleBlock width="40%"/>
            <SingleBlock width="20%">
                <Button label='Apply' onClick={onApply} disabled={false} />
            </SingleBlock>
            <SingleBlock width="40%"/>
            <AlertMessage/>
        </Wrapper>
    );
};
//
/*
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateRangePicker defaultValue={[defaultMin,defaultMax]} sx={{ fontSize: 10 }}  localeText={{ start: 'From', end: 'To' }} onChange={(newValue) => setValue(newValue)}/>
                </LocalizationProvider>
                */